import { IUnitServiceHistoryDto } from 'api/api';
import React from 'react';
import { localized } from 'state/i18n';
import WhiteCard from 'view/shared/components/cards/white-card';
import { cardDetailsStyles, cardGeneralClassNames } from '../constants';
import { ManualItem } from '../documents-helper';
import { DeviceDocumentButtons } from './device-document-buttons';
import { LatestUnitServiceHistoryDocuments } from './latest-unit-service-history-document';

interface DocumentDetailsProps {
	unitId: number;
	serialNumber: string;
	serviceDocuments: IUnitServiceHistoryDto[];
	isServiceTechnician: boolean;
	isAtleastCountryAdmin: boolean;
	canViewServiceHistory: boolean;
	handleVideoBtnPressed: (videoName: string) => void;
	manualItems: ManualItem[];
}

export const DocumentDetails: React.FC<DocumentDetailsProps> = ({
	unitId,
	serialNumber,
	serviceDocuments,
	isServiceTechnician,
	isAtleastCountryAdmin,
	canViewServiceHistory,
	handleVideoBtnPressed,
	manualItems,
}) => {
	const containerClassName = `${cardGeneralClassNames.classNameContainer} ${cardDetailsStyles.classNameContainer}`;

	return (
		<WhiteCard title={localized('DocumentsAndVideos')} classNameContainer={containerClassName}>
			<DeviceDocumentButtons
				machineDetailsId={serialNumber}
				handleVideoBtnPressed={handleVideoBtnPressed}
				manualItems={manualItems}
			/>

			{canViewServiceHistory && (
				<LatestUnitServiceHistoryDocuments
					unitId={unitId}
					serialNumber={serialNumber}
					serviceDocuments={serviceDocuments}
					canUpload={isServiceTechnician || isAtleastCountryAdmin}
				/>
			)}
		</WhiteCard>
	);
};
